<template>
  <single-panel-page>
    <h5>Reset password</h5>

    <div
      v-show="!passwordResetDone"
      class="form"
      :class="{ 'loader-cover': inProgress }"
    >
      <input
        v-model="password"
        class="form-control"
        type="password"
        placeholder="Password"
        autofocus
        @keyup.enter="submit()"
      />
      <password :value="password" />
    </div>

    <div v-show="passwordResetDone" class="row animated fadeIn">
      <div class="col-sm-12">
        <p class="text-success">
          Your password has been updated. We will take you to the login page
          now.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 text-right">
        <button
          v-show="!passwordResetDone"
          class="btn btn-block btn-primary text-uppercase"
          :disabled="inProgress"
          @click="submit()"
        >
          <span>Set new password</span>
        </button>
      </div>
    </div>

    <div slot="bottom">
      <span class="splash-box-footer">
        <router-link class="text-yellow" :to="{ name: 'login' }"
          >Login</router-link
        >
      </span>
    </div>
  </single-panel-page>
</template>

<script>
import Auth from 'services/Auth'
import { sleep } from 'utils'

export default {
  props: {
    userId: {
      type: [String, Number],
      default: '',
    },
    token: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      inProgress: false,
      passwordResetDone: false,
      password: '',
    }
  },
  methods: {
    async submit() {
      this.inProgress = true
      const { userId, password, token } = this
      const request = Auth.resetPassword({ userId, password, token })
      await sleep(2000)
      try {
        const response = await request
        this.passwordResetDone = true
        await sleep(3000)
        this.$router.push({ name: 'login' })
      } finally {
        this.inProgress = false
      }
    },
  },
}
</script>
